<template>
  <div class="upload" :class="{ disabled }">
    <Upload
      type="drag"
      action="#"
      :show-upload-list="false"
      :format="['jpg', 'jpeg', 'png']"
      :on-format-error="handleFormatError"
      :before-upload="handleBeforeUpload"
      :disabled="disabled"
      :multiple="multiple"
    >
      <slot>
        <div style="padding: 20px 0">
          <img v-if="previewUrl" :src="previewUrl" class="preview" />
          <Icon
            v-else
            type="ios-cloud-upload"
            size="52"
            style="color: #1456f0"
          ></Icon>
          <p>点击或拖拽选择文件</p>
        </div>
      </slot>
    </Upload>
    <div v-if="desc" style="color: #999; font-size: 12px;">
      <div v-for="(item,index) in desc" :key="index">{{item}}</div>
    </div>
  </div>
</template>
<style lang="stylus" scoped>
.upload
  position: relative

  &.disabled::before
    content: ''
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background: rgba(#ddd, 0.5)
    z-index: 1
    cursor: not-allowed

  .preview
    width: 100px
    height: 100px
</style>
<script>
export default {
  props: ['value', 'fieldModel', 'folder', 'disabled', 'multiple', 'desc'],
  data() {
    return {
      previewUrl: '',
    }
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue) {
            this.previewUrl = this.$envConst.IMAGE_ORIGIN + newValue
          } else {
            this.previewUrl = ''
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleFormatError() {
      this.$Notice.warning({
        title: '文件格式错误',
        desc: `请上传jpg或png格式文件`,
      })
    },
    handleBeforeUpload(file) {
      if (!this.folder) {
        return this.$Notice.warning({
          title: '上传错误',
          desc: `必须指定上传文件夹`,
        })
      }
      this.$emit('before-upload', '')
      let formData = new FormData()
      formData.append('folder', this.folder)
      formData.append('file', file)
      this.$axios.post('/funs/upload/image', formData).then((data) => {
        data=data+'?'+file.name;
        this.$emit('input', data)
        this.previewUrl = this.$envConst.IMAGE_ORIGIN + data
        this.$emit('on-change', this.$envConst.IMAGE_ORIGIN + data, data)
        // let reader = new FileReader()
        // reader.readAsDataURL(file)
        // reader.onload = () => {

        // }
      })
      return false
    },
  },
}
</script>
